import React from 'react';

const Heading = props => {
    return <div className='Heading'>
        <h1>The DRINQUIRY</h1>
    </div>;
};

export default Heading;
